import * as React from 'react';
import { useLocation } from 'react-use';
import { useActions, HollowOutGuideAction, useAppSelector } from '@web-common/state/createStore';
import useInView from './useInView';
import ImgBubbleGuide from './imgBubbleGuide/index';
import HasMaskGuiden from './hasMaskGuide/index';
import TipGuide from './tipGuide/index';
import { getSiteModule } from 'env_def';
import { apiHolder as api, inWindow } from 'api';
const storeApi = api.api.getDataStoreApi();
const HollowOutGuide = props => {
    const { type = '1', enable = true, guideId, step, noneUserRelated, hash = inWindow() ? window.location.hash : '', childrenRef, className = '' } = props;
    const location = useLocation();
    const onGuide = useAppSelector(state => state.hollowOutGuideReducer.guideQueue[0]);
    const { doAddGuide, doDeleteGuide } = useActions(HollowOutGuideAction);
    const hashMatched = React.useMemo(() => {
        if (!hash) {
            return true;
        }
        if (type !== '1') {
            return (location === null || location === void 0 ? void 0 : location.hash) === hash;
        }
        const cur = getSiteModule(window.location.hash);
        const target = getSiteModule(hash);
        return cur && target && cur.key === target.key;
    }, [location, hash, type]);
    const onStep = React.useMemo(() => (step ? step : 1), [step]);
    const show = React.useMemo(() => {
        var _a;
        return enable && hashMatched && onGuide && onGuide.guideId === guideId && ((_a = onGuide === null || onGuide === void 0 ? void 0 : onGuide.steps[onStep - 1]) === null || _a === void 0 ? void 0 : _a.show);
    }, [enable, hashMatched, onGuide, guideId, onStep]);
    const inView = useInView(childrenRef);
    React.useEffect(() => {
        if (enable && hashMatched && inView && type !== '1') {
            const mailDiscussGuideHasShowedStore = storeApi.getSync(guideId, { noneUserRelated: !!noneUserRelated });
            const { data, suc } = mailDiscussGuideHasShowedStore;
            if (suc && data === 'true') {
                return;
            }
            doAddGuide({ step: onStep, guideId, type, noneUserRelated });
        }
        else {
            doDeleteGuide({ step: onStep, guideId });
        }
    }, [enable, hashMatched, inView]);
    return (React.createElement(React.Fragment, null, type === '3' ? (React.createElement(TipGuide, Object.assign({}, props, { show, onStep }))) : type === '2' ? (React.createElement(ImgBubbleGuide, Object.assign({}, props, { show, onStep }))) : (React.createElement(HasMaskGuiden, Object.assign({}, props, { show: enable, onStep })))));
};
export default HollowOutGuide;
